module.exports = __webpack_public_path__ + "static/author-1-7f638bd99413c847ce6ec0f4ddff4e2c.jpg";